<template>
  <div class="flex-container">
    <div class="menubar flex-100">
      <span class="title">Wat is uw doel?</span>
    </div>

    <!-- Category Opbouwen -->
    <div class="title-option flex-100">
      <b>Pensioen opbouwen</b>
    </div>
    <div
      class="card option flex-25" @click="selectGoal('pensioen', '1')"
      v-if="$parent.intakeAdmin.beleggen.brand === 'Doelbeleggen'"
    >
      <h2><awesomeIcon icon="couch"/> Lijfrente (box{{'\xa0'}}1)</h2>
      <p>
        Lijfrente pensioenrekening. Heeft u nog jaar&shy;ruimte om belasting&shy;vriendelijk
        pensioen op te bouwen of een reservering in uw bedrijf die in een lijfrente over kan?
        <br /><strong>Met belastingvoordeel.</strong>
      </p>
    </div>
    <div class="card option flex-25" @click="selectGoal('pensioen')">
      <h2><awesomeIcon icon="golf-ball"/> Pensioen (box{{'\xa0'}}3)</h2>
      <p>
        U wilt binnen box 3 een potje voor uw pensioen opbouwen naast uw AOW en
        box{{'\xa0'}}1&shy;pensioen. Zo kunt u een extra aanvulling opbouwen voor elk gewenst
        moment.
        <br /><strong>Zonder belastingvoordeel.</strong>
      </p>
    </div>
    <div class="card option flex-25" @click="selectGoal('gouden-handdruk-opbouwend', '1')">
      <h2><awesomeIcon icon="handshake"/> Gouden handdruk</h2>
      <p>
        Heeft u een gouden handdruk polis die u nog even wilt laten doorlopen?
        Of een gouden handdruk stamrecht in de BV die u om wilt zetten naar
        een gouden handdruk rekening?
      </p>
    </div>
    <div class="card option flex-25" @click="selectGoal('netto-lijfrente-opbouwend', '1')">
      <h2><awesomeIcon icon="suitcase"/> Netto lijfrente</h2>
      <p>
        Heeft u een inkomen van ruim boven &euro;{{'\xa0'}}100.000 en nog jaar&shy;ruimte om
        belastingvriendelijk (box{{'\xa0'}}3 vrijgesteld)-pensioen op te bouwen of een reservering
        in uw bedrijf die in een lijfrente over kan?
      </p>
    </div>

    <!-- Category Uitkeren -->
    <div class="title-option flex-100">
      <b>Pensioen uitkeren</b>
    </div>
    <div
      class="card option flex-25" @click="selectGoal('levensonderhoud', '1')"
      v-if="$parent.intakeAdmin.beleggen.brand === 'Doelbeleggen'"
    >
      <h2><awesomeIcon icon="hand-holding-heart"/> Lijfrente (box{{'\xa0'}}1)</h2>
      <p>
        Direct ingaande lijfrente. Komt uw lijfrente binnenkort vrij, wilt u uitkeren en daarbij
        (blijven) beleggen? Dan biedt dit doel de unieke mogelijkheid om aan het begin van uw
        pensioen meer uitgekeerd te krijgen.
      </p>
    </div>
    <div class="card option flex-25" @click="selectGoal('gouden-handdruk-uitkerend', '1')">
      <h2><awesomeIcon icon="handshake"/> Gouden handdruk</h2>
      <p>
        Heeft u een gouden handdruk polis die expireert of een gouden handdruk stamrecht
        in de BV en staat u voor de keuze om (uiterlijk op uw AOW-leeftijd)
        een periodieke uitkering te starten?
      </p>
    </div>
    <div class="card option flex-25" @click="selectGoal('netto-lijfrente-uitkerend', '1')">
      <h2><awesomeIcon icon="suitcase"/> Netto lijfrente</h2>
      <p>
        Box 3 vrijgesteld. Komt uw Netto lijfrente binnenkort vrij, wilt u uitkeren en daarbij
        (blijven) beleggen? Dit product biedt de mogelijkheid om aan het begin van
        uw pensioen meer uitgekeerd te krijgen.
      </p>
    </div>

    <!-- Category Kind -->
    <div class="title-option flex-100">
      <b>Voor uw (klein-)kind</b>
    </div>
    <div class="card option flex-25" @click="selectGoal('studiekinderen')">
      <h2><awesomeIcon icon="graduation-cap"/> Schenken</h2>
      <p>
        U wilt direct schenken aan uw (klein)-kind om ze op weg te helpen met een potje geld voor
        later. Voor de studie of de aan&shy;schaf van de eerste woning. Het kan allemaal met
        deze minderjarige rekening op naam van het kind.
      </p>
    </div>
    <div class="card option flex-25" @click="selectGoal('studiekinderen-ouders')">
      <h2><awesomeIcon icon="child"/> Op uw naam</h2>
      <p>
        U wilt zelf voor uw (klein)-kind een potje geld sparen en later schenken. Voor de studie
        of de aanschaf van de eerste woning. Let op dat het geld bij deze optie niet op naam van
        het kind komt en u dit later kan schenken.
      </p>
    </div>

    <!-- Category Overige -->
    <div class="title-option flex-100">
      <b>Overige doelen</b>
    </div>
    <div class="card option flex-25" @click="selectGoal('vermogensopbouw')">
      <h2><awesomeIcon icon="business-time"/> Rendement</h2>
      <p>
        U heeft geen concrete doel&shy;stelling, maar u wilt wel uw vermogen laten groeien.
        De mate van groei kan gebaseerd zijn op de vermogens&shy;belasting,
        de inflatie of een combinatie daarvan.
      </p>
    </div>
    <div
      class="card option flex-25" @click="selectGoal('groteaankoop')"
      v-if="$parent.intakeAdmin.beleggen.brand === 'Doelbeleggen'"
    >
      <h2><awesomeIcon icon="car"/> Doelbedrag</h2>
      <p>
        U bent niet de eerste die zijn of haar oog op iets moois heeft laten vallen.
        Misschien een mooie oldtimer of een zeldzaam horloge? Wij helpen u graag op weg.
      </p>
    </div>
    <div class="card option flex-25" @click="selectGoal('hypotheek')">
      <h2><awesomeIcon icon="home"/> Hypotheek</h2>
      <p>
        U heeft wellicht een aflossings&shy;vrije hypotheek die u toch een keer moet aflossen.
        Het kan voordelig zijn zelf daarvoor een potje op te bouwen.
      </p>
    </div>
    <div class="card option flex-25" @click="selectGoal('levensonderhoud')">
      <h2><awesomeIcon icon="heart"/> Inkomen</h2>
      <p>
        U heeft een mooi netto bedrag opgebouwd waar u inkomen uit wilt realiseren.
        Door te (blijven) beleggen kunt u wellicht langer inkomen uit uw vermogen halen.
      </p>
    </div>

  </div>
</template>

<script>
export default {
  name: 'IntakeGoalSelectPage',
  emits: ['update:model-value'],
  props: {
    modelValue: Object,
  },
  methods: {
    selectGoal(goal, box = '3') {
      this.modelValue.goalData.type = goal;
      this.modelValue.goalData.box = box;
      this.modelValue.goalData.step = 2;
      delete this.modelValue.goalData.targetDate;
      if (goal === 'studiekinderen-ouders') {
        this.modelValue.goalData.type = 'studiekinderen';
        this.modelValue.rekeningData.type = 'Particuliere rekening';
        this.modelValue.rekeningData.step = 0;
        this.modelValue.persoonsData.splice(1);
        this.modelValue.persoonsData[0].type = 'Rekeninghouder';
      } else if (goal === 'studiekinderen') {
        this.modelValue.rekeningData.type = 'Minderjarige rekening';
        this.modelValue.rekeningData.step = 0;
        this.modelValue.persoonsData.splice(1);
        this.modelValue.persoonsData[0].type = 'Volmacht';
        this.modelValue.persoonsData.push({ type: 'Minderjarige' });
      } else {
        this.modelValue.rekeningData.type = 'Particuliere rekening';
        this.modelValue.rekeningData.step = 0;
        this.modelValue.persoonsData.splice(1);
        this.modelValue.persoonsData[0].type = 'Rekeninghouder';
      }
      for (let i = 0; i < this.$parent.intake.persoonsData.length; i += 1) {
        if (this.$parent.intake.goalData.box === '1') {
          delete this.$parent.intake.persoonsData[i].herkomstVermogenSalaris;
          delete this.$parent.intake.persoonsData[i].herkomstVermogenErfenis;
          delete this.$parent.intake.persoonsData[i].herkomstVermogenSchenking;
          delete this.$parent.intake.persoonsData[i].herkomstVermogenWoningverkoop;
          delete this.$parent.intake.persoonsData[i].herkomstVermogenBedrijfsverkoop;
          delete this.$parent.intake.persoonsData[i].herkomstVermogenBox1lijfrente;
          delete this.$parent.intake.persoonsData[i].herkomstVermogenBox3lijfrente;
          delete this.$parent.intake.persoonsData[i].herkomstVermogenGoudenhanddruk;
          delete this.$parent.intake.persoonsData[i].herkomstVermogenCryptovaluta;
          delete this.$parent.intake.persoonsData[i].herkomstVermogenAnders;
          this.$parent.intake.persoonsData[i].woningVerkoopPostcode = '';
          this.$parent.intake.persoonsData[i].woningVerkoopHuisnummer = '';
          this.$parent.intake.persoonsData[i].woningVerkoopToevoeging = '';
        }
      }
      if (this.$parent.intake.goalData.box === '3') {
        this.$parent.intake.transferData.overdrachten = [];
      }
      this.$parent.setDefaults();
    },
  },
};
</script>

<style lang="scss" scoped>
.title-option {
  background: #e9ecf2;
  color: $color-background;
  padding: 10px 20px;
  border-radius: $br;
  // padding-bottom: 10px;
}
.flex-container {
  column-gap: 20px;
  row-gap: 20px;
  @media #{$mobile} {
    row-gap: 10px;
    padding: 43px 10px 10px;
  }
}
</style>
